// proto/v2/settings/settings.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file settings/settings.proto (package lvdr.v2.settings, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file settings/settings.proto.
 */
export const file_settings_settings: GenFile = /*@__PURE__*/
  fileDesc("ChdzZXR0aW5ncy9zZXR0aW5ncy5wcm90bxIQbHZkci52Mi5zZXR0aW5ncyIjChJHZXRTZXR0aW5nc1JlcXVlc3QSDQoFc2NvcGUYASABKAkiUQoVVXBkYXRlU2V0dGluZ3NSZXF1ZXN0Eg0KBXNjb3BlGAEgASgJEikKCHNldHRpbmdzGAIgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdCJMChBTZXR0aW5nc1Jlc3BvbnNlEg0KBXNjb3BlGAEgASgJEikKCHNldHRpbmdzGAIgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdCJPChRTZXR0aW5nc0NoYW5nZWRFdmVudBINCgVzY29wZRgBIAEoCRISCgpjaGFuZ2VkX2J5GAIgASgJEhQKDGNoYW5nZWRfa2V5cxgDIAMoCSIYChZHZXRVc2VyU2V0dGluZ3NSZXF1ZXN0IkYKGVVwZGF0ZVVzZXJTZXR0aW5nc1JlcXVlc3QSKQoIc2V0dGluZ3MYASABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0IkEKFFVzZXJTZXR0aW5nc1Jlc3BvbnNlEikKCHNldHRpbmdzGAEgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdEIpWidnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvc2V0dGluZ3NiBnByb3RvMw", [file_google_protobuf_struct]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.settings.GetSettingsRequest
 */
export type GetSettingsRequest = Message<"lvdr.v2.settings.GetSettingsRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;
};

/**
 * Describes the message lvdr.v2.settings.GetSettingsRequest.
 * Use `create(GetSettingsRequestSchema)` to create a new message.
 */
export const GetSettingsRequestSchema: GenMessage<GetSettingsRequest> = /*@__PURE__*/
  messageDesc(file_settings_settings, 0);

/**
 * @generated from message lvdr.v2.settings.UpdateSettingsRequest
 */
export type UpdateSettingsRequest = Message<"lvdr.v2.settings.UpdateSettingsRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: google.protobuf.Struct settings = 2;
   */
  settings?: JsonObject | undefined;
};

/**
 * Describes the message lvdr.v2.settings.UpdateSettingsRequest.
 * Use `create(UpdateSettingsRequestSchema)` to create a new message.
 */
export const UpdateSettingsRequestSchema: GenMessage<UpdateSettingsRequest> = /*@__PURE__*/
  messageDesc(file_settings_settings, 1);

/**
 * Responses
 *
 * @generated from message lvdr.v2.settings.SettingsResponse
 */
export type SettingsResponse = Message<"lvdr.v2.settings.SettingsResponse"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: google.protobuf.Struct settings = 2;
   */
  settings?: JsonObject | undefined;
};

/**
 * Describes the message lvdr.v2.settings.SettingsResponse.
 * Use `create(SettingsResponseSchema)` to create a new message.
 */
export const SettingsResponseSchema: GenMessage<SettingsResponse> = /*@__PURE__*/
  messageDesc(file_settings_settings, 2);

/**
 * Events
 *
 * @generated from message lvdr.v2.settings.SettingsChangedEvent
 */
export type SettingsChangedEvent = Message<"lvdr.v2.settings.SettingsChangedEvent"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: string changed_by = 2;
   */
  changedBy: string;

  /**
   * @generated from field: repeated string changed_keys = 3;
   */
  changedKeys: string[];
};

/**
 * Describes the message lvdr.v2.settings.SettingsChangedEvent.
 * Use `create(SettingsChangedEventSchema)` to create a new message.
 */
export const SettingsChangedEventSchema: GenMessage<SettingsChangedEvent> = /*@__PURE__*/
  messageDesc(file_settings_settings, 3);

/**
 * User-scoped requests (Wave 1 HTTP→WS migration).
 * These pin the scope to the caller's user ID (from the WS connection);
 * callers never pass a scope string.
 *
 * @generated from message lvdr.v2.settings.GetUserSettingsRequest
 */
export type GetUserSettingsRequest = Message<"lvdr.v2.settings.GetUserSettingsRequest"> & {
};

/**
 * Describes the message lvdr.v2.settings.GetUserSettingsRequest.
 * Use `create(GetUserSettingsRequestSchema)` to create a new message.
 */
export const GetUserSettingsRequestSchema: GenMessage<GetUserSettingsRequest> = /*@__PURE__*/
  messageDesc(file_settings_settings, 4);

/**
 * @generated from message lvdr.v2.settings.UpdateUserSettingsRequest
 */
export type UpdateUserSettingsRequest = Message<"lvdr.v2.settings.UpdateUserSettingsRequest"> & {
  /**
   * patch; merged into existing
   *
   * @generated from field: google.protobuf.Struct settings = 1;
   */
  settings?: JsonObject | undefined;
};

/**
 * Describes the message lvdr.v2.settings.UpdateUserSettingsRequest.
 * Use `create(UpdateUserSettingsRequestSchema)` to create a new message.
 */
export const UpdateUserSettingsRequestSchema: GenMessage<UpdateUserSettingsRequest> = /*@__PURE__*/
  messageDesc(file_settings_settings, 5);

/**
 * @generated from message lvdr.v2.settings.UserSettingsResponse
 */
export type UserSettingsResponse = Message<"lvdr.v2.settings.UserSettingsResponse"> & {
  /**
   * current full user-level settings
   *
   * @generated from field: google.protobuf.Struct settings = 1;
   */
  settings?: JsonObject | undefined;
};

/**
 * Describes the message lvdr.v2.settings.UserSettingsResponse.
 * Use `create(UserSettingsResponseSchema)` to create a new message.
 */
export const UserSettingsResponseSchema: GenMessage<UserSettingsResponse> = /*@__PURE__*/
  messageDesc(file_settings_settings, 6);

